module.exports = __webpack_public_path__ + "static/img/jrqi.512aaf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jrqi.jpg
// module id = ylAS
// module chunks = 0